import axios from "axios";

const ENDPOINT_KEY = "orderForm";
const ENDPOINT_URI = "/order-form";

export default function usePrescriptionService() {
  return {
    queryKey: ENDPOINT_KEY,
    getPrescriptions: async (
      campaignId,
      search = "",
      from = "",
      to = "",
      page = 1,
      limit = 10
    ) => {
      const params = new URLSearchParams({
        page,
        limit,
      });
      if (campaignId) {
        params.append("campaignId", campaignId);
      }
      if (search) {
        params.append("search", search);
      }
      if (from) {
        params.append("from", from);
      }
      if (to) {
        params.append("to", to);
      }
      const response = await axios.get(`${ENDPOINT_URI}`, {
        params,
      });
      return response.data.payload;
    },
    getPrescriptionById: async (id) => {
      const response = await axios.get(`${ENDPOINT_URI}/${id}`);
      return response.data.payload;
    },
  };
}
